import { Controller } from "@hotwired/stimulus";

// Previene el cierre del modal cuando el submit fue al endpoint intermedio
// "Obtener giros" (paso 1 → paso 2 del modal OpenFactura).
//
// Background: `manage--modal` escucha `turbo:submit-end` en su element y
// cierra el modal en cualquier submit exitoso (`e.detail.success === true`).
// El botón "Obtener giros" hace submit via formaction a /integrations/openfactura/giros,
// que responde 200 + turbo_stream reemplazando el modal_form — el modal
// controller lo interpreta como "form terminó con éxito" y cierra.
//
// Solución: al hacer click en el botón, armamos un listener one-shot en
// document con capture phase = true que stopPropagation el próximo
// turbo:submit-end. Corre ANTES del listener del modal controller (que está
// en bubble phase en un div descendiente), detiene la cadena, y el modal
// permanece abierto mientras Turbo procesa el turbo_stream de respuesta.
//
// El submit del paso 2 ("Activar"/"Guardar") NO dispara armPreventClose:
// sigue el flujo normal y el modal cierra como debe.
export default class extends Controller {
  armPreventClose() {
    const handler = (event) => {
      event.stopPropagation();
      document.removeEventListener("turbo:submit-end", handler, true);
    };
    document.addEventListener("turbo:submit-end", handler, true);
  }
}
